<template>
    <path d="M13.343 10.434H4.414l-.007 3.132h8.936v4.7L19.593 12l-6.25-6.266z"/>
</template>

<script>
    export default {
        name: 'arrow-right-2',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/ArrowRight2.vue